import * as Article1 from './WhatIsIntelligence';
import * as Article2 from './WorldModels';
import * as Article3 from './DeepFakes';
import * as Article4 from './DestroyerOfJobs';
import * as Article5 from './LetsAccelerate';

const articles: Record<string, { Component: React.FC; meta?: any }> = {
  'we-should-work-on-ai-again': { Component: Article1.default, meta: (Article1 as any).meta },
  'intro-to-world-models': { Component: (Article2 as any).default, meta: (Article2 as any).meta },
  'deep-fakes': { Component: (Article3 as any).default, meta: (Article3 as any).meta },
  'destroyer-of-jobs': { Component: (Article4 as any).default, meta: (Article4 as any).meta },
  'lets-accelerate': { Component: (Article5 as any).default, meta: (Article5 as any).meta },
};



export default articles;
